import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { PremiumSlider } from '@root/features/premium'
import { mediaMinTablet } from '@root/shared/ui-kit'

type Props = {
  mode: 'single' | 'carousel'
  slideSize?: number
}

export const PremiumScreenSlider: React.FC<Props> = ({ mode, slideSize }) => (
  <Root>
    <Title>
      <Trans i18nKey="premium.slider.title" components={[<span key={0} />]} />
    </Title>
    <PremiumSlider
      mode={mode}
      slideSize={slideSize}
      css={css`
        --slider-image-width: 90%;
        --slider-width: 340px;

        display: grid;
        margin: 0 auto;
        min-height: 233px;

        object {
          margin-top: -10px;
        }
      `}
    />
  </Root>
)

const Root = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
`

const Title = styled(Typography).attrs({
  variant: 'body2-bold',
  component: 'div',
})`
  color: var(--text-12);
  text-align: center;

  span {
    background: linear-gradient(
      92deg,
      var(--subscriptionGradientFrom-9) 35.79%,
      var(--subscriptionGradientTo-9) 58.66%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  ${mediaMinTablet(css`
    font-size: var(--typography-body-1-bold-font-size);
    line-height: var(--typography-body-1-bold-line-height);
    font-weight: var(--typography-body-1-bold-font-weight);
  `)}
`
